module.exports = __webpack_public_path__ + "static/media/tony-4row.d7f33c0d.png";